import AntdSlider      from 'antd/lib/slider';
import { SliderMarks } from 'antd/lib/slider';
import View            from '@widesk-ui/components/View';

export type SliderProps = Omit<FieldProps, 'value' | 'onChange'> & {
	min?: number;
	max?: number;
	marks?: SliderMarks;
	step?: number;
	showValue?: boolean;
	unit?: string;
} & ({
	range: true;
	value?: number[];
	onChange?: (value: number[]) => void;
	onAfterChange?: (value: number[]) => void;
} | {
	range?: false;
	value?: number;
	onChange?: (value: number) => void;
	onAfterChange?: (value: number) => void;
});

export default function Slider(props: SliderProps) {
	const { onAfterChange, ...restProps } = props;
	const slider = (
		<AntdSlider
			{...restProps}
			onChangeComplete={onAfterChange as any}
			max={props.max || 100}
			min={props.min || 0}
			style={{
				minWidth: 150,
				...props.style,
			}}
			tooltip={props.unit ? { formatter: value => `${value}${props.unit}` } : undefined}
		/>
	);

	return props.showValue && props.value ? (
		<View centerV noWrap gapH="xs" row>
			{slider}
			{Array.isArray(props.value)
				? <span>Entre {props.value[0]} et {props.value[1]}{props.unit}</span>
				: <span>{props.value}{props.unit}</span>
			}
		</View>
	) : slider;
}